module.exports = __webpack_public_path__ + "img/thumbnail_CuviersDwarfCaiman_j_normal.4629c612.png";